module.exports = __webpack_public_path__ + "static/edible_icon-81b2a9ae6b4e511edeeac6fa62540c07.svg";